import {Typography} from '@toppy-webshop/toppy-design-system';

interface AddressProps {
    name: string;
    address: string;
    postcode: string;
    city: string;
    country_id: string;
    telephone?: string;
}

const countryCodeMapping: {[key: string]: string} = {
    NL: 'Nederland',
    BE: 'België',
    DE: 'Deutschland',
};

const Address = ({
    name,
    address,
    postcode,
    city,
    country_id,
    telephone,
}: AddressProps) => {
    return (
        <Typography variant="address" size={'s'} preWrap>
            {name}
            {'\n'}
            {address}
            {'\n'}
            {postcode} {city}
            {'\n'}
            {countryCodeMapping[country_id] || country_id}
            {'\n'}
            {telephone}
        </Typography>
    );
};

export default Address;
